/**
 * FlashCointainer
 * Container for flashmessages
 *
 * @class   FlashContainer
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';

export default class FlashContainer extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		let classes = ClassNames(
			this.props.className,
			'lui-flash-message-container',
		{
			'lui-fixed': this.props.fixed
		});

		return (
			<div>
				<div className={classes}>{this.props.children}</div>
			</div>
		);
	}

}

FlashContainer.propTypes = {
	fixed: React.PropTypes.bool
};

FlashContainer.defaultProps = {
	fixed: true
};



/** WEBPACK FOOTER **
 ** ./src/components/flash-message/FlashContainer.js
 **/